<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Finalizar Evento Masivo</v-toolbar>
        <v-card-text>
          <v-container class="mt-1 text-center">
            <p>Finalizar el evento masivo</p>
            <p class="mb-0"><b>ID:</b> {{ evento.id }}</p>
            <p class="mb-0"><b>Codigo Punto Venta:</b> {{ evento.codigoPuntoVenta }}</p>
            <p class="mb-0"><b>Codigo Sucursal:</b> {{ evento.codigoSucursal }}</p>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            Finalizar
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        evento: {
          codigoPuntoVenta: 0,
          codigoSucursal: 0,
          id: 0,
        },
      };
    },
    components: {},
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.loading = false;
        let numsucursal = this.$route.query.numsucursal;
        let codigopunto = this.$route.query.codigopunto;
        this.evento.codigoPuntoVenta = codigopunto;
        this.evento.codigoSucursal = numsucursal;
        this.evento.id = item.id;
        if (!numsucursal) this.evento.codigoSucursal = item.sucursal.codigoSucursal;
        if (!codigopunto) this.evento.codigoPuntoVenta = item.puntoVenta.codigoPuntoVenta;
        window.console.log(item);
      },
      save() {
        this.msg = '';
        //if (!this.evento.codigoPuntoVenta) this.msg = 'No hay codigoPuntoVenta.';
        //if (!this.evento.codigoSucursal) this.msg = 'No hay codigoSucursal.';
        if (!this.evento.id) this.msg = 'No hay id.';
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        //if (this.evento.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo/finalizar`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: this.evento,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('eventofin::', data);
            vue.$emit('fineventomasivo', data);
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data.mensajesList[0].codigo} - ${data.mensajesList[0].descripcion}`;

            vue.loading = false;
          });
      },
    },
  };
</script>
